import { useCallback, useMemo } from "react";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { OccupancyOptionsEntity } from "../../domain/OccupancyOptions.entity";
import { GetConfigurationByPropertyNameRequest } from "../../../../gen/witbooking/backoffice/propertyconfiguration/v1/propertyconfiguration_api_pb";
import { PropertyConfigurationAPIPromiseClient } from "../../../../gen/witbooking/backoffice/propertyconfiguration/v1/propertyconfiguration_api_grpc_web_pb";

export function usePropertyConfigurationApi() {
  const grpcClient = useGrpcClient(PropertyConfigurationAPIPromiseClient);
  const getConfigurationByPropertyName = usePropertyGrpcCall(
    grpcClient,
    grpcClient.getConfigurationByPropertyName
  );

  const getOccupancyOptions = useCallback(async () => {
    const request = new GetConfigurationByPropertyNameRequest();
    request.setPropertiesList([
      "occupationType",
      "fltr_tipo_ocupacion",
      "minedadnino",
      "maxedadnino",
      "babyMinAge",
      "teenagerMaxAge",
      "adultMaxAge",
      "filterGuestsByAge",
      "baseAccommodationType",
    ]);
    const response = await getConfigurationByPropertyName(request);
    return OccupancyOptionsEntity.fromMap(response.toObject().configurationsMap);
  }, [getConfigurationByPropertyName]);

  return useMemo(
    () => ({
      getOccupancyOptions,
    }),
    [getOccupancyOptions]
  );
}
